/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Chips_LabelInputs */

const en_us2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are you training today?`)
};

const pt_br2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você treina hoje?`)
};

const es_419_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde entrenas hoy?`)
};

const pt_pt2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde treinas hoje?`)
};

const fr_fr2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où t'entraînes-tu aujourd'hui ?`)
};

const de_de2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo trainierst du heute?`)
};

const it_it2_gyms_chips_label = /** @type {(inputs: Gyms_Chips_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove ti alleni oggi?`)
};

/**
* | output |
* | --- |
* | "Where are you training today?" |
*
* @param {Gyms_Chips_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_chips_label = /** @type {((inputs?: Gyms_Chips_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Chips_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_chips_label(inputs)
	if (locale === "es-419") return es_419_gyms_chips_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_chips_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_chips_label(inputs)
	if (locale === "de-DE") return de_de2_gyms_chips_label(inputs)
	if (locale === "it-IT") return it_it2_gyms_chips_label(inputs)
	return en_us2_gyms_chips_label(inputs)
});
export { gyms_chips_label as "gyms.chips_label" }